import React, {FC} from 'react';
import {useCtxConfig} from 'pages/dashboard/components/FirstLook/context';
import {Screen} from 'pages/dashboard/components/FirstLook/Screens/Screen';

import * as styles from './styles.module.scss';

const introVideo = 'https://static.bodyspec.com/at/7a/05/7a05efd719479858';

export const Intro: FC = () => {
	const {state, dispatch} = useCtxConfig();
	return (
		<Screen className={styles.intro}>
			<video
				key={state.index}
				src={introVideo}
				autoPlay
				muted
				playsInline
				onEnded={() => {
					dispatch({type: 'NEXT_SCREEN'});
				}}
			/>
		</Screen>
	);
};
